import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CompanyService } from "src/app/services/company.service";
import { CustomerService } from "src/app/services/customer.service";
import Swal from "sweetalert2";
import { NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { AlphaNumericValidation, EmailValidation, MobileNumberValidation, regexPattern, TelephoneNumberValidation } from "src/app/models/validator";
import { RateBandsService } from "src/app/services/ratebands.service";
import { lastValueFrom } from "rxjs";
import { GeoService } from "src/app/services/geo.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { AppCoreService } from "src/app/services/app-core.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Title } from "@angular/platform-browser";
import { CheckboxCellSelectComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-select-cell.component";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { CheckboxCellComponent } from "src/app/components/shared/ag-grid/cell-renderers/checkbox-cell.component";
import { NetworkService } from "src/app/services/network.service";
import { Utilities } from "src/app/models/utilities";
import { MiscService } from "src/app/services/misc/misc.service";
import { TemplateService } from "src/app/services/system-config/template/templates.service";

@Component({
  selector: 'app-addcustomer',
  templateUrl: './addcustomer.component.html',
  styleUrls: ['./addcustomer.component.scss']
})
export class AddCustomerComponent implements OnInit, AfterViewInit {
  customerForm: FormGroup;
  isFormSubmitted: boolean;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  industryTypeList: any[] = [];
  salesExecutiveList: [];
  companyList: any[];
  customerTypeList: any[] = [];
  rateBandList: any[] = [];
  documentOptions: any[] = [{ name: 'GSTIN (Normal)' }, { name: 'PAN Number' }, { name: 'Aadhaar Number' }, { name: 'Passport Number' }, { name: 'TAN Number' }, { name: 'VAT Number' }, { name: 'EORI' }, { name: 'FDA' }, { name: 'Others' }];
  billingCountryList = [];
  stateList = [];
  pickupCountryList = [];
  pickupStateList = [];
  cityList = [];
  paymentTypeList = ['Credit', 'Cash', 'COD'];
  billingTypeList = ['Daily', 'Weekly', 'Fortnightly', 'Monthly'];
  businessTypeList = [];
  selectedCustomerLogoFile: File | null = null;
  customerLogoFileName = '';
  customerLogoFileURL = '';
  selectedSignatureFile: File | null = null;
  signatureFileName = '';
  signatureFileURL = '';
  selectedKycFile: File | null = null;
  kycList = [];
  rowData = [];

  selectedSCId: number;
  currencyList = [];
  useEnterKey: boolean;

  showLogoProgressBar = false;
  showsignatrueProgressBar = false;
  showkycProgressbar = false;
  kycProgress: number = 0;
  logoProgress: number = 0;
  signatrueProgress: number = 0;
  docValidationMsg: string;
  invoiceTemplateList: any[];
  serviceCenterRowData: any[] = [];
  originalServiceCenterData: any[] = [];
  selectedServiceCenterData: any[] = [];

  isRateBandSubmitted = false;
  rateBandPeriodList = [];

  isKYCInfoSubmitted = false;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 3,
    // domLayout: 'autoHeight'
    rowSelection: 'multiple',
    suppressRowClickSelection: true
  }

  serviceCenterColumnDefs = [
    { cellRenderer: CheckboxCellSelectComponent, maxWidth: 40 },
    { headerName: 'Code', field: 'code', maxWidth: 120 },
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Is Billing', field: 'isbilling', maxWidth: 80, cellRenderer: CheckboxCellComponent }
  ];
  limitChars: number;
  billingStateList = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private companyService: CompanyService,
    private customerService: CustomerService,
    private rateBandsService: RateBandsService,
    private geoService: GeoService,
    private fileHandlerService: FileHandlerService,
    private appCoreService: AppCoreService,
    private utilities: Utilities,
    private userManagmentService: UserManagementService,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private miscService: MiscService,
    private networkService: NetworkService,
    private templateService: TemplateService
  ) {
    titleService.setTitle('Customers');
    this.context = {
      componentParent: this,
      componentName: 'AddCustomerComponent',
    }
  }

  async ngOnInit() {
    this.customerTypeList = ['Customer', 'Co-Courier', 'Franchisee'];
    this.businessTypeList = ['B2B', 'B2C', 'SEZWP'];
    const currentDate = this.utilities.FormatDateWithTime()?.dateString;
    this.customerForm = this.formBuilder.group({
      txtCode: [null, Validators.compose([Validators.required, Validators.maxLength(5)])],
      ddlCompanies: [null, Validators.required],
      txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      txtContactPerson: [null, Validators.compose([Validators.maxLength(50)])],
      txtEmailId: [null, Validators.compose([EmailValidation, Validators.required])],
      txtMobile: [null, MobileNumberValidation],
      ddlIndustryType: [],
      ddlinvoiceTemplate: [null],
      // txtFax: [null],
      ddlCustomerType: ['Customer'],
      customerLogoFileControl: [null],
      signatureFileControl: [null],
      ddlCurrency: [null],
      chkPrintAWBWithCustomerLogo: [null],
      locationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.required],
        ddlState: [null, Validators.required],
        ddlCity: [null, Validators.required],
        txtPincode: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
      status: ['true'],

      kycdetails: this.formBuilder.group({
        ddlDocumentType: [],
        txtDocumentNo: [{ value: null, disabled: true }],
        txtDocument: [null],
        documentFileControl: [null],
        documentFileUrl: ''
      }),

      businessDetails: this.formBuilder.group({
        ddlBusinessType: ['B2B'],
        ddlSalesExecutive: [null],
        ddlBillingType: [this.billingTypeList[0], Validators.compose([Validators.required])],
        ddlPaymentType: [this.paymentTypeList[0], Validators.compose([Validators.required])],
        fuelApplicable: [false],
        taxApplicable: [false],
        ddlCountry: [null, Validators.compose([Validators.required])],
        ddlState: [null, Validators.compose([Validators.required])],

        // ddlPickupCountry: [null, Validators.compose([Validators.required])],
        // ddlPickupState: [null, Validators.compose([Validators.required])],
        // ddlPickupCity: [null, Validators.compose([Validators.required])],
      }),

      ratePeriodGroup: this.formBuilder.group({
        ddlRateBand: [null],
        txtFromDate: [null],
        txtToDate: [null]
      }),

      bankDetails: this.formBuilder.group({
        txtBankName: [null],
        txtAccountNo: [null, Validators.pattern(/^[a-zA-Z0-9]{1,20}$/)],
        txtAccountName: [null],
        txtIfscCode: [null, AlphaNumericValidation],
        txtMicr: [null, Validators.pattern(/^\d{9}$/)],
        txtBankAddress: [null],
        // txtBankAdCode: [null, Validators.compose([Validators.maxLength(30)])],
        // nfeiCheck: [null],
        // ddlFirm: [null]
      }),

      lutdetails: this.formBuilder.group({
        txtLutBondNo: [null, Validators.compose([Validators.maxLength(30)])],
        lutIssueDate: [null],
        lutTillDate: [null]
      }),
    });

    this.isFormSubmitted = false;
    this.checkPermission();
    if (this.permConfig.isAddAllowed) {
      this.bindIndustries();
      await this.bindServiceCenter();
      this.bindCompanies();
      this.getAllRateBands();
      this.bindCountries();
      this.bindTemplates();
      // this.getAllEventConfig();
      this.appCoreService.SelectedServiceCenter().subscribe(val => {
        this.selectedSCId = val;
        this.bindUsers(val);
        // this.bindUserLocationOverSc();
      });
      this.customerForm.get('locationdetails.ddlState').valueChanges.subscribe(newState => {
        newState && this.applyGSTValidation();
      });

      this.customerForm.get('kycdetails.ddlDocumentType').valueChanges.subscribe(newState => {
        const docNoControl = this.customerForm.get('kycdetails.txtDocumentNo');
        newState ? docNoControl.enable() : docNoControl.disable();
      });
    }
  }

  applyGSTValidation() {
    const docNoControl = this.customerForm.get('kycdetails.txtDocumentNo');
    const stateisocode = this.customerForm.get('locationdetails.ddlState')?.value;

    const taxCode = this.stateList?.find(row => row.isocode === stateisocode)?.taxcode;

    // Dynamically create the GSTIN regex pattern based on the state code
    const gstPattern = taxCode && `^(${taxCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`;

    // Now, update the regexPattern with the new dynamic pattern
    regexPattern.gstValidation = new RegExp(gstPattern);  // Update regex pattern
    docNoControl.setValidators([Validators.pattern(regexPattern.gstValidation)]);
    docNoControl.updateValueAndValidity();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.customerForm) : null;
  }

  addRatePeriod() {
    this.customerForm.get('ratePeriodGroup').get('ddlRateBand').setValidators([Validators.required]);
    this.customerForm.get('ratePeriodGroup').get('txtFromDate').setValidators([Validators.required]);
    this.customerForm.get('ratePeriodGroup').get('txtToDate').setValidators([Validators.required]);

    this.customerForm.get('ratePeriodGroup').get('ddlRateBand').updateValueAndValidity();
    this.customerForm.get('ratePeriodGroup').get('txtFromDate').updateValueAndValidity();
    this.customerForm.get('ratePeriodGroup').get('txtToDate').updateValueAndValidity();
    this.isRateBandSubmitted = true;

    if (this.customerForm.get('ratePeriodGroup').valid) {
      const ratebandObj: any = this.rateBandList.find((x: any) =>
        x.id == this.customerForm.get('ratePeriodGroup').get('ddlRateBand').value
      );

      const rateBandPeriodObj = {
        ratebandid: ratebandObj.id,
        rateband: ratebandObj.rateband,
        fromdate: this.customerForm.get('ratePeriodGroup').get('txtFromDate').value,
        todate: this.customerForm.get('ratePeriodGroup').get('txtToDate').value,
      };

      const isDuplicate = this.rateBandPeriodList.some((item) =>
      ((new Date(rateBandPeriodObj.fromdate) >= new Date(item.fromdate) && new Date(rateBandPeriodObj.fromdate) <= new Date(item.todate)) ||
        (new Date(rateBandPeriodObj.todate) >= new Date(item.fromdate) && new Date(rateBandPeriodObj.todate) <= new Date(item.todate)) ||
        (new Date(rateBandPeriodObj.fromdate) <= new Date(item.fromdate) && new Date(rateBandPeriodObj.todate) >= new Date(item.todate))
      )
      );

      if (!isDuplicate) {
        this.rateBandPeriodList.push(rateBandPeriodObj);
      } else {
        this.appCoreService.showMessage('A record of same period is already exits', 'Duplicate record', 'error');
      }
      this.isRateBandSubmitted = false;
      this.customerForm.get('ratePeriodGroup').get('ddlRateBand').clearValidators();
      this.customerForm.get('ratePeriodGroup').get('txtFromDate').clearValidators();
      this.customerForm.get('ratePeriodGroup').get('txtToDate').clearValidators();
      this.customerForm.get('ratePeriodGroup').reset();
    }
    this.customerForm.get('ratePeriodGroup').get('ddlRateBand').updateValueAndValidity();
    this.customerForm.get('ratePeriodGroup').get('txtFromDate').updateValueAndValidity();
    this.customerForm.get('ratePeriodGroup').get('txtToDate').updateValueAndValidity();
  }

  deleteRateBandItem(idx) {
    let message = `This action is irreversible. Are you sure you want to delete?`;
    this.openWarningDialog(message).then((response) => {
      if (response) {
        this.rateBandPeriodList.splice(idx, 1);
      }
    });
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Customers');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  // getAllEventConfig() {
  //   this.notificationService.GetAllEventConfig().subscribe(res => {
  //     if (res?.success) {
  //       this.rowData = res.data;
  //       this.rowData = this.rowData.map((item) => { return { ...item, isemaildisable: !item.isemail, issmsdisable: !item.issms, iswhatsappdisable: !item.iswhatsapp } });
  //     }
  //   })
  // }

  // saveConfig(rowData: any) {
  //   this.rowData = rowData;
  // }



  bindUsers(servicecenterid) {
    try {
      this.userManagmentService.GetUserByGroup('se', servicecenterid).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          // console.log('userdata', data);
          this.salesExecutiveList = data.filter((item: any) => item.usergroupname === 'Sales Executive');
        }
      })
    }
    catch (err) {
      console.error(err);
    }
  }

  bindIndustries() {
    try {
      this.miscService.GetAllIndustries().subscribe((res) => {
        if (res && res.success) {
          this.industryTypeList = res.data;
        }
      });

    } catch (e) {
      console.error(e);
    }
  }

  bindCompanies() {
    try {
      this.companyService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.companyList = res.data;
          const defaultCompanyObj = this.companyList.filter(x => x.isdefault === true);
          this.customerForm.get('ddlCompanies').setValue(defaultCompanyObj);

          //bind service centers
          if (defaultCompanyObj) {
            this.onCompaniesChange(defaultCompanyObj);
          }
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  onCompaniesChange(companies?: any) {
    let selectedCompanies = this.customerForm.get('ddlCompanies')?.value ?? companies;

    if (selectedCompanies && selectedCompanies.length) {

      // Collect unique allocated service center IDs from selected companies
      const ServiceCenters = Array.from(
        new Set(selectedCompanies.flatMap(company => company.servicecenters || []))
      );
      // Filter the service center data based on the unique allocated service center IDs
      this.serviceCenterRowData = this.originalServiceCenterData.filter(serviceCenter =>
        ServiceCenters.includes(serviceCenter.id)
      );
    } else {
      this.serviceCenterRowData = []; // Reset if no companies are selected
    }
  }

  async bindServiceCenter() {
    const res = await lastValueFrom(this.networkService.GetAllServiceCenters({ isactive: true }));
    if (res && res.success && res.data?.length) {
      this.originalServiceCenterData = res.data.sort((a, b) => Number(a.disabled) - Number(b.disabled));
      this.serviceCenterRowData = this.originalServiceCenterData;
    }
  }


  getAllRateBands() {
    try {
      this.rateBandsService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.rateBandList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  onChangeFileSelect(evt, selectedType: string) {
    try {
      if (evt) {
        if (selectedType === 'CustomerLogo') {
          this.selectedCustomerLogoFile = evt.target.files[0];
        } else if (selectedType === 'Signature') {
          this.selectedSignatureFile = evt.target.files[0];
        } else if (selectedType === 'Kyc') {
          this.selectedKycFile = evt.target.files[0];
        }

      }
    } catch (e) {
      console.error(e);
    }
  }

  uploadFile(selectedType: string) {
    let interval: any;
    let timeout: any;
    try {
      if (selectedType === 'CustomerLogo') {
        if (this.selectedCustomerLogoFile) {
          this.showLogoProgressBar = true;
          this.logoProgress = 0;
          interval = setInterval(() => {
            if (this.logoProgress < 99) {
              this.logoProgress += 1;
            }
          }, 100);
          timeout = setTimeout(() => {
            if (this.logoProgress >= 99 && this.logoProgress < 100) {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
              this.showLogoProgressBar = false;
              clearInterval(interval);
            }
          }, 5000);
          this.ngxLoaderService.start();
          let requestObj = {
            name: this.selectedCustomerLogoFile.name,
            fileType: this.selectedCustomerLogoFile.type,
            category: 'customer'
          };

          this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
            try {
              if (res && res.success) {
                const signedUrl = res.data.uploadURL;
                const fileId = res.data.fileId;
                if (signedUrl) {
                  let headers: HttpHeaders = new HttpHeaders({
                    "Content-Type": requestObj.fileType
                  });

                  this.fileHandlerService.UploadFile(signedUrl, this.selectedCustomerLogoFile, headers).subscribe((f) => {
                    if (f === null) {
                      // console.log('F', f);
                      this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                        if (res && res.success) {
                          // console.log(res);
                          this.customerForm.get('customerLogoFileControl').setValue(fileId);
                          this.customerLogoFileName = res.data.name;
                          this.customerLogoFileURL = res.data.url;
                          this.logoProgress = 100;
                          clearInterval(interval);
                          clearTimeout(timeout);
                          setTimeout(() => {
                            this.showLogoProgressBar = false;
                          }, 1000);
                          this.ngxLoaderService.stop();
                        }
                      });
                    }
                  });
                }
              }
            } catch (error) {
              this.ngxLoaderService.stop();
              console.error(error);
            }
          });
        } else {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('Please select a file to upload', '', 'error');
        }

      } else if (selectedType === 'Signature') {
        this.showsignatrueProgressBar = true;
        this.signatrueProgress = 0;
        interval = setInterval(() => {
          if (this.signatrueProgress < 99) {
            this.signatrueProgress += 1;
          }
        }, 100);
        timeout = setTimeout(() => {
          if (this.signatrueProgress >= 99 && this.signatrueProgress < 100) {
            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
            this.showsignatrueProgressBar = false;
            clearInterval(interval);
          }
        }, 5000);
        this.ngxLoaderService.start();
        let requestObj = {
          name: this.selectedSignatureFile.name,
          fileType: this.selectedSignatureFile.type,
          category: 'customer'
        };

        this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
          try {
            if (res && res.success) {
              const signedUrl = res.data.uploadURL;
              const fileId = res.data.fileId;
              if (signedUrl) {
                let headers: HttpHeaders = new HttpHeaders({
                  "Content-Type": requestObj.fileType
                });
                this.fileHandlerService.UploadFile(signedUrl, this.selectedSignatureFile, headers).subscribe((f) => {
                  if (f === null) {
                    // console.log('F', f);
                    this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                      if (res && res.success) {
                        // console.log(res);
                        this.customerForm.get('signatureFileControl').setValue(fileId);
                        this.signatureFileName = res.data.name;
                        this.signatureFileURL = res.data.url;
                        this.signatrueProgress = 100;
                        clearInterval(interval);
                        clearTimeout(timeout);
                        setTimeout(() => {
                          this.showsignatrueProgressBar = false;
                        }, 1000);
                        this.ngxLoaderService.stop();
                      }
                    });
                  }
                });
              }
            }
          } catch (error) {
            this.ngxLoaderService.stop();
            console.error(error);
          }
        });
      } else {
        this.ngxLoaderService.stop();
        this.appCoreService.showMessage('Please select a file to upload', '', 'error');
      }

    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  addCustomer() {
    if (!this.permConfig.isAddAllowed) {
      this.warningDialog('No access to Add.');
      return;
    }

    this.isFormSubmitted = true;
    if (this.customerForm.invalid) {
      return;
    }

    const gstObj = this.kycList.find((kyc) => kyc.type === 'GSTIN (Normal)');

    if (this.customerForm.get('businessDetails.ddlBusinessType')?.value === 'B2B' && !gstObj) {
      return this.appCoreService.showMessage('GSTIN (Normal) is required for B2B Business Type.', '', 'error');
    }

    if (gstObj) {
      const stateisocode = this.customerForm.get('locationdetails.ddlState').value
      const statecode = this.stateList.find(row => row.isocode === stateisocode)?.taxcode;

      const documentStateCode = gstObj && gstObj.no.slice(0, 2);
      const isGstValid = documentStateCode && statecode === documentStateCode;

      if (!isGstValid)
        return this.appCoreService.showMessage('Invalid GST No format', 'Error', 'error');
    }

    if (this.customerForm.get('lutdetails.lutIssueDate')?.value > this.customerForm.get('lutdetails.lutTillDate')?.value) {
      this.appCoreService.showMessage('LUT Issue Date exceed LUT Till Date.', 'Warning', 'warning');
      return;
    }

    this.isFormSubmitted = true;
    if (this.permConfig.isAddAllowed && this.customerForm.valid) {
      const locationForm = this.customerForm.get('locationdetails');
      const businessForm = this.customerForm.get('businessDetails');
      let customerArea = locationForm.get('txtArea')?.value;
      customerArea = (typeof customerArea === 'string') ? customerArea : customerArea?.area;
      let custPincode = locationForm.get('txtPincode')?.value
      custPincode = (typeof custPincode === 'string') ? custPincode : custPincode?.pincode;
      // console.log(this.customerForm.get('ddlCompanies').value);
      const comapnyObj = this.customerForm.get('ddlCompanies').value;
      const requestObj = {
        code: this.customerForm.get('txtCode').value.toUpperCase(),
        companyids: comapnyObj.map(x => { return x.id }),
        name: this.customerForm.get('txtName').value?.trim(),
        contactperson: this.customerForm.get('txtContactPerson').value,
        emailid: this.customerForm.get('txtEmailId').value,
        // mobile: this.customerForm.get('txtMobile').value,
        // fax: this.customerForm.get('txtFax').value,
        customertype: this.customerForm.get('ddlCustomerType').value,
        logoid: this.customerForm.get('customerLogoFileControl').value,
        signatorylogoid: this.customerForm.get('signatureFileControl').value,
        allocatedservicecenters: this.selectedServiceCenterData,
        templateid: this.customerForm.get('ddlinvoiceTemplate').value,        
        location: {
          country: locationForm.get('ddlCountry').value,
          state: locationForm.get('ddlState').value,
          city: locationForm.get('ddlCity').value,
          area: customerArea,
          pincode: custPincode,
          address1: locationForm.get('txtAddress1').value,
          address2: locationForm.get('txtAddress2').value,
          mobileno: locationForm.get('txtMobileNo').value,
          tel: locationForm.get('txtTelephoneNo').value
        },
        kyc: this.kycList,
        salesexecutiveid: businessForm.get('ddlSalesExecutive').value,
        fuelapplicable: businessForm.get('fuelApplicable').value,
        taxapplicable: businessForm.get('taxApplicable').value,
        billingtype: businessForm.get('ddlBillingType').value,
        paymenttype: businessForm.get('ddlPaymentType').value,
        businesstype: businessForm.get('ddlBusinessType').value,
        billinginfo: {
          country: businessForm.get('ddlCountry').value,
          state: businessForm.get('ddlState').value,
        },
        status: this.customerForm.get('status').value,
        industrytypeid: this.customerForm.get('ddlIndustryType').value,
        generatedfromid: this.selectedSCId,
        currency: this.customerForm.get('ddlCurrency').value,
        printawbwithcustomerlogo: this.customerForm.get('chkPrintAWBWithCustomerLogo').value,
        additionaldetails: {
          bankname: this.customerForm.get('bankDetails.txtBankName')?.value,
          bankaccountno: this.customerForm.get('bankDetails.txtAccountNo')?.value,
          bankadcode: this.customerForm.get('bankDetails.txtBankAdCode')?.value,
          bankaccountname: this.customerForm.get('bankDetails.txtAccountName')?.value,
          bankaddress: this.customerForm.get('bankDetails.txtBankAddress')?.value,
          bankifsc: this.customerForm.get('bankDetails.txtBankIfsc')?.value,
          micr: this.customerForm.get('bankDetails.txtMicr')?.value,
          firm: this.customerForm.get('bankDetails.ddlFirm')?.value,
          nfei: this.customerForm.get('bankDetails.nfeiCheck')?.value,

          lutbondno: this.customerForm.get('lutdetails.txtLutBondNo')?.value,
          lutissuedate: this.customerForm.get('lutdetails.lutIssueDate')?.value,
          luttilldate: this.customerForm.get('lutdetails.lutTillDate')?.value
        },
        ratebandperiods: this.rateBandPeriodList?.map(rb => ({
          ratebandid: String(rb.ratebandid),
          fromdate: new Date(rb.fromdate),
          todate: new Date(rb.todate)
        })) || [],
      }
      // console.log('this.serviceCenterRowData',this.serviceCenterRowData);
      // console.log('this.selectedServiceCenterData',this.selectedServiceCenterData);
      if (this.serviceCenterRowData.length === 0) {
        this.createCustomer(requestObj);
      } else if (this.serviceCenterRowData.length > 0 && this.selectedServiceCenterData.length > 0) {
        const hasBilling = this.selectedServiceCenterData.some(center => center.isbilling === true);
        if (hasBilling) {
          this.createCustomer(requestObj);
        } else {
          this.appCoreService.showMessage('Please add one service center as billing', '', 'error');
        }
      } else {
        this.appCoreService.showMessage('Please add one service center as billing', '', 'error');
      }

    }
  }

  createCustomer(requestObj: any) {
    this.ngxLoaderService.start();
    this.customerService.Add(requestObj).subscribe((res) => {
      try {
        if (res && !res.success) {
          this.ngxLoaderService.stop();
          if (res.data?.err_msg)
            return this.appCoreService.showMessage(res.data?.err_msg, 'Error', 'error');
        }
        else if (res && res.success) {
          this.ngxLoaderService.stop();
          this.openSuccessDialog('Record Added Successfully');
        }

      }
      catch (err) {
        console.error(err);
        this.ngxLoaderService.stop();
      }
    });
  }



  onCheckBoxChange(event) {
    // console.log('onCheckBoxChange', event)
    if (event.checked && event?.rowdata?.id) {
      // Check if the item is not already present in selectedServiceCenterData - insertion of new row 
      if (!this.selectedServiceCenterData?.some(item => item.id === event.rowdata.id)) {
        this.selectedServiceCenterData?.push({ id: event.rowdata.id, isbilling: true, active: true });
      }

      // Update grid
      this.serviceCenterRowData = this.serviceCenterRowData.map(serviceCenter => {
        if (serviceCenter.id === event.rowdata.id) {
          return { ...serviceCenter, active: true, isbilling: true };
        } else {
          return { ...serviceCenter, isbilling: false };
        }
      });
      // console.log('this.serviceCenterRowData', this.serviceCenterRowData)
      // Take objects from grid to update selectedServiceCenterData
      this.selectedServiceCenterData = this.serviceCenterRowData.filter(item => {
        return this.selectedServiceCenterData?.some(selectedItem => selectedItem.id === item.id);
      }).map(({ id, active, isbilling }) => ({ id, active, isbilling }));
    }
  }

  onCheckSelectBoxChange(event) {

    const rowData = this.serviceCenterRowData?.find(x => x?.id === event?.rowdata?.id);
    if (event.checked) {
      if (event?.rowdata?.id) {
        const selectedServiceCenterIndex = this.selectedServiceCenterData.findIndex(x => x.id === rowData.id);
        if (selectedServiceCenterIndex === -1) {
          this.selectedServiceCenterData.push(
            {
              id: rowData.id,
              code: rowData.code,
              name: rowData.name,
              active: true,
              isbilling: event?.rowdata?.isbilling || false
            }
          );
        } else {
          this.selectedServiceCenterData[selectedServiceCenterIndex].id = rowData.id;
          this.selectedServiceCenterData[selectedServiceCenterIndex].code = rowData.code;
          this.selectedServiceCenterData[selectedServiceCenterIndex].name = rowData.name;
          this.selectedServiceCenterData[selectedServiceCenterIndex].active = true;
          this.selectedServiceCenterData[selectedServiceCenterIndex].isbilling = event?.rowdata?.isbilling || false;
        }
      }
    } else {
      const selectedServiceCenterIndex = this.selectedServiceCenterData.findIndex(x => x.id === rowData.id);
      if (selectedServiceCenterIndex !== -1) {
        this.selectedServiceCenterData.splice(selectedServiceCenterIndex, 1);
      }
    }
    this.serviceCenterRowData = this.serviceCenterRowData.map(serviceCenter => ({
      ...serviceCenter,
      active: this.selectedServiceCenterData.find(x => x.id === serviceCenter.id)?.active,
      isbilling: this.selectedServiceCenterData.find(x => x.id === serviceCenter.id)?.isbilling
    }));
    // console.log('serviceCenterRowData', this.serviceCenterRowData)
    // console.log('selectedServiceCenterData', this.selectedServiceCenterData)
  }

  getLocation(selectedLocation: any) {
    this.stateList = selectedLocation?.[0]?.state;
  }

  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          this.billingCountryList = res.data;
          this.pickupCountryList = res.data;
          this.currencyList = this.pickupCountryList?.filter((x) => x.currencycode !== '' && x.currencycode !== null)
            .reduce((acc, curr) => {
              if (!acc.some((item) => item.currencycode === curr.currencycode)) {
                acc.push(curr);
              }
              return acc;
            }, []);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  async bindCitiesByState(stateCode?: string): Promise<void> {
    try {
      if (stateCode) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.cityList = res.data;
        } else {
          throw new Error('Error fetching data');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onCountryChange(formControlName: string) {
    const selectedValue = this.customerForm.get('businessDetails').get(formControlName).value;
    // const selectedValue = this.customerForm.get(formGp == 'pickup' ? 'pickupOrigin' : 'billingState').get('ddlCountry').value;
    if (formControlName === 'ddlCountry') {
      this.billingStateList = [];
      this.customerForm.get('businessDetails').get('ddlState').reset();
    }
    // else if (formControlName === 'ddlPickupCountry') {
    //   this.pickupStateList = [];
    //   this.cityList = [];
    //   this.customerForm.get('businessDetails').get('ddlPickupState').reset();
    //   this.customerForm.get('businessDetails').get('ddlPickupCity').reset();
    // } 
    this.bindStatesByCountry(selectedValue, formControlName);
  }

  async bindStatesByCountry(countryCode?: string, formControlName?: string): Promise<void> {
    try {
      if (countryCode) {
        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          // formControlName === 'ddlPickupCountry' ? this.pickupStateList = res.data : this.stateList = res.data;
          this.billingStateList = res.data;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onStateChange(formControlName: string) {
    const selectedValue = this.customerForm.get('businessDetails').get(formControlName).value;
    // const selectedValue = this.customerForm.get(formGp == 'pickup' ? 'pickupOrigin' : 'billingState').get('ddlState').value;
    if (formControlName === 'ddlPickupState') {
      this.cityList = [];
      this.customerForm.get('businessDetails').get('ddlPickupCity').reset();
      this.bindCitiesByState(selectedValue);
    }
  }

  async openSuccessDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/setup/customers']);
    }
  }

  async addkycInfo(isuploaded?: boolean) {
    this.isKYCInfoSubmitted = true;
    this.customerForm.get('kycdetails').get('ddlDocumentType').updateValueAndValidity();

    if (!isuploaded) {
      this.customerForm.get('kycdetails').get('txtDocumentNo').addValidators([Validators.required]);
      this.customerForm.get('kycdetails').get('txtDocumentNo').updateValueAndValidity();
    }

    let selectedDocumentType = this.customerForm.get('kycdetails').get('ddlDocumentType')?.value;
    let selectedDocumentNo = this.customerForm.get('kycdetails').get('txtDocumentNo')?.value;

    const reqObj = {
      documenttype: selectedDocumentType,
      documentno: selectedDocumentNo
    };

    if (selectedDocumentType === 'GSTIN (Normal)') {
      const res = await lastValueFrom(this.customerService.checkKyc(reqObj));
      if (res && res.success) {
        if (res.data.err_msg) {
          this.appCoreService.showMessage("GSTIN number already taken", 'Error', 'error');
          return;
        } else {
          this.processKYCInfo(reqObj);
        }
      }
    } else {
      this.processKYCInfo(reqObj);
    }
  }

  private processKYCInfo(reqObj: any) {
    let fileUrl = this.customerForm.get('kycdetails')?.get('documentFileUrl')?.value || null;
    let fileId = this.customerForm.get('kycdetails')?.get('documentFileControl')?.value || null;
    const typeExists = this.kycList.some((k) => k.type === reqObj.documenttype);

    if (!typeExists) {
      if (this.customerForm.get('kycdetails').valid && reqObj.documenttype) {
        const kycInfo = {
          type: reqObj.documenttype,
          no: reqObj.documentno,
          filepath: fileUrl,
          fileid: fileId,
          entitytype: 'Customer'
        };
        this.kycList = [...this.kycList, kycInfo];
        this.isKYCInfoSubmitted = false;
        this.customerForm.get('kycdetails').get('ddlDocumentType').clearValidators();
        this.customerForm.get('kycdetails').get('txtDocumentNo').clearValidators();
        this.customerForm.get('kycdetails').reset();
      }
    } else {
      this.appCoreService.showMessage('Document type already exists', '', 'error');
    }
  }


  uploadKyc() {
    let interval: any;
    let timeout: any;
    this.isKYCInfoSubmitted = true;
    this.customerForm.get('kycdetails').get('ddlDocumentType').addValidators([Validators.required]);
    this.customerForm.get('kycdetails').get('ddlDocumentType').updateValueAndValidity();
    try {
      if (this.selectedKycFile && this.customerForm.get('kycdetails').valid) {
        this.showkycProgressbar = true;
        this.kycProgress = 0;
        interval = setInterval(() => {
          if (this.kycProgress < 99) {
            this.kycProgress += 1;
          }
        }, 100);
        timeout = setTimeout(() => {
          if (this.kycProgress >= 99 && this.kycProgress < 100) {
            this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
            this.showkycProgressbar = false;
            clearInterval(interval);
          }
        }, 5000);
        this.ngxLoaderService.start();
        let requestObj = {
          name: this.selectedKycFile.name,
          fileType: this.selectedKycFile.type,
          category: 'kyc'
        };

        this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
          try {
            if (res && res.success) {
              const signedUrl = res.data.uploadURL;
              const fileId = res.data.fileId;
              if (signedUrl) {
                let headers: HttpHeaders = new HttpHeaders({
                  "Content-Type": requestObj.fileType
                });
                this.fileHandlerService.UploadFile(signedUrl, this.selectedKycFile, headers).subscribe((f) => {
                  if (f === null) {

                    this.fileHandlerService.UploadComplete({ id: fileId }).subscribe(async (res) => {
                      if (res && res.success) {
                        this.customerForm.get('kycdetails').get('documentFileControl').setValue(fileId);
                        this.customerForm.get('kycdetails').get('documentFileUrl').setValue(res.data.url);
                        if (this.kycList.length > 0) {
                          const forDocument = this.customerForm.get('kycdetails').get('ddlDocumentType').value;
                          const documentExists = this.kycList.some(document => document.type === forDocument);
                          // console.log('documentExists', documentExists)
                          if (documentExists) {
                            this.kycList.forEach(document => {
                              if (document.type === forDocument) {
                                document.type = forDocument;
                                document.filepath = this.customerForm.get('kycdetails').get('documentFileUrl').value;
                                document.fileid = this.customerForm.get('kycdetails').get('documentFileControl').value;
                              }
                            });
                          } else {
                            await this.addkycInfo(true);
                          }
                        } else {
                          await this.addkycInfo(true);
                        }
                        this.isKYCInfoSubmitted = false;
                        this.customerForm.get('kycdetails').get('ddlDocumentType').clearValidators();
                        this.customerForm.get('kycdetails').reset();
                        this.kycProgress = 100;
                        clearInterval(interval);
                        clearTimeout(timeout);
                        setTimeout(() => {
                          this.showkycProgressbar = false;
                        }, 1000);
                        this.ngxLoaderService.stop();
                      }
                    });
                  }
                });
              }
            }
          } catch (error) {
            this.ngxLoaderService.stop();
            console.error(error);
          }
        });

      } else {
        this.ngxLoaderService.stop();
        this.appCoreService.showMessage('For adding a KYC, you must provide valid document type, number and supporting file', '', 'error');
      }


    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }

  }

  deleteKycItem(itemId: number, idx) {
    let message = `This action is irreversible. Are you sure you want to delete?`;
    this.openWarningDialog(message).then((response) => {
      if (response) {
        this.kycList.splice(idx, 1);
      }
    });

  }

  documentTypeValidation(): void {
    const docType = this.customerForm.get('kycdetails.ddlDocumentType').value;
    const docNoControl = this.customerForm.get('kycdetails.txtDocumentNo');

    let msg: string;
    let regex: any;
    let chars: number;

    // Get the dynamic state code
    const stateisocode = this.customerForm.get('locationdetails.ddlState').value;
    const taxtCode = this.stateList.find(row => row.isocode === stateisocode)?.taxcode;

    // Dynamically create the GSTIN regex pattern based on the state code
    const gstPattern = `^(${taxtCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`;
    regexPattern.gstValidation = new RegExp(gstPattern);  // Update regex pattern

    // Assign regex, message, and limitChars based on docType
    switch (docType) {
      case 'Aadhaar Number':
        regex = regexPattern.adhaarValidation;
        msg = 'Invalid Aadhaar No. Format.';
        chars = 12;
        break;
      case 'PAN Number':
        regex = regexPattern.panValidation;
        msg = 'Invalid PAN No. Format.';
        chars = 10;
        break;
      case 'GSTIN (Normal)':
        regex = regexPattern.gstValidation;
        msg = 'Invalid GST No. Format.';
        chars = 15;
        break;
      case 'Others':
        regex = regexPattern.maxCharacterDocValidation;
        msg = 'Max 150 characters allowed.';
        chars = 150;
        break;
      default:
        regex = regexPattern.generalDocValidation;
        msg = 'Max 30 characters allowed.';
        chars = 30;
        break;
    }

    // Store the limitChars and validation message for use in the template if needed
    this.docValidationMsg = msg;
    this.limitChars = chars;  // Added storing limitChars for external access

    // Set Validators with limitChars and regex validation
    docNoControl.setValidators([
      Validators.required,
      Validators.pattern(regex)]) // Added max length validator
    docNoControl.updateValueAndValidity();
  }

  trimDocumentNo(e: any) {
    const newDocumentNO = e.target.value.replace(/\s/g, "");
    this.customerForm.get('kycdetails.txtDocumentNo').setValue(newDocumentNO);
  }

  async openWarningDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    return result.isConfirmed;
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  // bindUserLocationOverSc() {
  //   this.networkService.GetServiceCentersById(this.selectedSCId).subscribe((res) => {
  //     if (res && res.success) {
  //       let location = res?.data[0]?.location;
  //       if (location) {
  //         this.customerForm.get('locationdetails.ddlCountry').setValue(location.country);
  //         this.customerForm.get('locationdetails.ddlState').setValue(location.state);
  //         this.customerForm.get('locationdetails.ddlCity').setValue(location.city);
  //       }
  //     }
  //   })
  // }

  bindTemplates() {
    try {
      this.templateService.getAllTemplates().subscribe((res) => {
        if (res && res.success) {
          this.invoiceTemplateList = res.data.filter(x => x.category.toLowerCase() === 'invoice');
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

}